// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"701":"catalog","894":"services"}[chunkId] || chunkId) + "." + {"430":"08bfaeeb","513":"3a24e02b","701":"15966965","894":"c9ac2922"}[chunkId] + ".js";
};